import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DEVICE_TYPES } from 'src/app/shared/interfaces/ISettings';
import { DEFAULT_LANGUAGE, KILL_SWITCH_MODE } from 'src/app/shared/utils/constants';

import { SettingsState } from './settings.reducer';

export const selectSettingsState = createFeatureSelector<SettingsState>('settings');

export const selectSettings = createSelector(selectSettingsState, (state) => state.settings);

export const selectSettingDevice = createSelector(
  selectSettingsState,
  (state) => state.settings.device
);

export const selectFrodoSettings = createSelector(
  selectSettingsState,
  (state) => state.settings.apps.frodo
);

export const selectSettingStyle = createSelector(selectFrodoSettings, (state) => state.style);

export const selectSettingTimeouts = createSelector(
  selectSettingsState,
  (state) => state.settings.order.timeouts
);

export const selectSettingDispensingTimeout = createSelector(
  selectSettingsState,
  (state) => state.settings.order.timeouts.dispensing
);

export const selectSettingHomescreen = createSelector(
  selectFrodoSettings,
  (state) => state.homescreen
);

export const selectSettingValidatePresenceSensor = createSelector(
  selectSettingDevice,
  (device) => device.validatePresenceSensor
);

export const selectSettingSmartPickup = createSelector(
  selectSettingDevice,
  (device) => device.smartPickup
);

export const selectSettingDefaultScreen = createSelector(
  selectFrodoSettings,
  (state) => state.homescreen.defaultScreen
);

export const selectSettingAvailableScreen = createSelector(
  selectFrodoSettings,
  (state) => state.homescreen.availableScreens
);

export const selectSettingLogo = createSelector(selectSettingStyle, (state) => state.logo);

export const selectSettingIsLoaded = createSelector(selectSettingsState, (state) => state.isLoaded);

export const selectSettingLoadFailed = createSelector(
  selectSettingsState,
  (state) => state.loadFailed
);

export const selectSettingLoadSettled = createSelector(
  selectSettingIsLoaded,
  selectSettingLoadFailed,
  (isLoaded, loadFailed) => isLoaded || loadFailed
);

export const selectSettingIsActivated = createSelector(
  selectSettingDevice,
  (state) => state.isActivated
);

export const selectSettingsAccessCodeMaxLength = createSelector(
  selectSettingsState,
  (state) => state.settings.accessCode.length.maximum
);

export const selectSettingsAccessCodeMinLength = createSelector(
  selectSettingsState,
  (state) => state.settings.accessCode.length.minimum
);

export const selectSettingsAllowAlphanumeric = createSelector(
  selectSettingsState,
  (state) => state.settings.accessCode.allowAlphanumeric
);

export const selectSettingsAllowSymbols = createSelector(
  selectSettingsState,
  (state) => state.settings.accessCode.allowSymbols
);

export const selectSettingFrodoConfirmPickupTimeout = createSelector(
  selectSettingsState,
  (state) => state.settings.apps.frodo.timeouts.confirmPickup
);

export const selectSettingLanguage = createSelector(
  selectSettingsState,
  (state) => state.settings.location.language ?? DEFAULT_LANGUAGE
);

export const selectSettingKillSwitchMode = createSelector(
  selectSettingsState,
  (state) => state.settings.device.killSwitch?.mode ?? KILL_SWITCH_MODE.OFF
);

export const selectSettingDeviceType = createSelector(
  selectSettingsState,
  (state) => state.settings.device.deviceType
);

export const selectSettingFrodoTimeouts = createSelector(
  selectSettingsState,
  (state) => state.settings.apps.frodo.timeouts
);

export const selectSettingFrodoHandedOff = createSelector(
  selectSettingsState,
  (state) => state.settings.apps.frodo.handedOff
);

export const isDeviceArrayFrontLoading = createSelector(
  selectSettingDeviceType,
  (deviceType) => deviceType === DEVICE_TYPES.ARRAY_FL
);

export const selectLaunchScreenEnabled = createSelector(
  selectFrodoSettings,
  (state) => state.launchScreen.enable ?? true
);
